/**
 * The article contents rail.
 *
 * The list is rendered by `template-parts/content-article.php` with the first
 * item marked current; the shared scroll spy moves that mark to the h2 the
 * reader has reached.
 */

import { scrollSpy } from './scroll-spy';

export function ArticleToc() {
	const list = document.querySelector( '[data-article-toc]' );

	if ( ! list ) {
		return;
	}

	scrollSpy( Array.from( list.querySelectorAll( '[data-article-jump]' ) ) );
}
